import axios from 'axios';
import { apiPath } from './apiBase';

const API = axios.create({ baseURL: apiPath() });

// Attach JWT token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('yamass_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const register    = (data)  => API.post('/auth/register', data);
export const login       = (data)  => API.post('/auth/login', data);
export const googleLogin = (data)  => API.post('/auth/google', data);
export const getMe       = ()      => API.get('/auth/me');
export const forgotPassword = (data) => API.post('/auth/forgot-password', data);
export const resetPassword = (token, data) => API.post(`/auth/reset-password/${token}`, data);

// Products
export const getProducts  = (params) => API.get('/products', { params });
export const getProduct   = (id)     => API.get(`/products/${id}`);
export const getFeatured  = ()       => API.get('/products/featured');
export const createProduct = (data)  => API.post('/products', data);
export const updateProduct = (id, d) => API.put(`/products/${id}`, d);
export const deleteProduct = (id)    => API.delete(`/products/${id}`);

// Orders
export const createOrder      = (data) => API.post('/orders', data);
export const getMyOrders      = ()     => API.get('/orders/my');
export const getOrder         = (id)   => API.get(`/orders/${id}`);
export const markOrderPaid    = (id, d)=> API.put(`/orders/${id}/pay`, d);
export const updateOrderStatus= (id, d)=> API.put(`/orders/${id}/status`, d);
export const getAllOrders      = ()     => API.get('/orders');

// Returns
export const createReturn  = (data) => API.post('/returns', data);
export const getMyReturns  = ()     => API.get('/returns/my');
export const getAllReturns  = ()     => API.get('/returns');
export const updateReturn  = (id,d) => API.put(`/returns/${id}`, d);

// Admin
export const getAdminStats = () => API.get('/admin/stats');

// Users
export const getProfile    = ()     => API.get('/users/profile');
export const updateProfile = (data) => API.put('/users/profile', data);
